export function AdminLogin(type, url, userData){
    // let baseUrl = "http://yornee.com/api/"+url;
    let baseUrl = process.env.REACT_APP_BASEAPI_URL+url;
    //console.log(JSON.stringify(userData));
    return new Promise((resolve, reject)=>{
        fetch(baseUrl,{
            'method':type,
            headers:{'Content-Type':'application/json',
                    // Authorization: `Bearer ${accessToken}`,
                    Accept: 'application/json'
                    },
            body:JSON.stringify(userData)
        })
        .then((response)=>response.json())
        .then((responseJson) => {
            resolve(responseJson);
        })
        .catch((error) => {
            reject(error);
        });
        
    })
}
export function AdminDetail(url,type,token){
    let baseUrl = process.env.REACT_APP_BASEAPI_URL+url;
   // console.log(token);
    return new Promise((resolve, reject) =>{
        fetch(baseUrl,{
            'method':type,
            'headers':{
                'Content-Type':'application/json',
                Accept:'application/json',
                Authorization:'Bearer '+token

            },
            //'body':JSON.stringify(data)
        }).then((response)=>response.json())
        .then((responseJson)=>{
            resolve(responseJson);
        })
        .then()
        .catch((error)=>{
            reject(error);
        })
    })
}

export function changeAdminPassword(url,type, token,userData){
    let baseUrl = process.env.REACT_APP_BASEAPI_URL+url;
    return new Promise((resolve, reject)=>{
        fetch(baseUrl,{
            "method":type,
            'headers':{
                'Content-Type':'application/json',
                Accept:'application/json',
                Authorization:'Bearer '+token

            },
            body:JSON.stringify(userData),
        }).then((response)=>response.json())
         .then((responseJson)=>{
            resolve(responseJson);
        }).catch((error)=>{
            reject(error);
        })
    })
}

export function AdminLogout(url, type, token, data){
   // console.log(token)
   let baseUrl = process.env.REACT_APP_BASEAPI_URL+url;
    return new Promise((resolve, reject)=>{
        fetch(baseUrl,{
            "method":type,
            'headers':{
                'Content-Type':'application/json',
                Accept:'application/json',
                Authorization:'Bearer '+token
            },
            body:JSON.stringify(data),
        }).then((response)=>response.json())
        .then((responseJson)=>{
            resolve(responseJson);
        })
        .catch((error) =>{
            reject(error);
        })
    })

}

export function AdminProfile(url,type, token, data){
    let baseUrl = process.env.REACT_APP_BASEAPI_URL+url;
    return new Promise((resolve, reject)=>{
        fetch(baseUrl,{
            'method':type,
            'headers':{
                'Content-Type':'application/json',
                Accept:'application/json',
                Authorization:'Bearer '+token
            },
            body:JSON.stringify(data),
        }).then((response)=>response.json())
        .then((responseJson)=>{
            resolve(responseJson);
        })
        .then((error)=>{
            reject(error);
        })
    })
}

// export function AdminLogout(url, type, token, data){
//     //console.log(token)
//     let baseUrl = "http://localhost:8000/api/"+url;
//     const ad = fetch(baseUrl,{
//             "method":type,
//             'headers':{
//                 'Content-Type':'application/json',
//                 Accept:'application/json',
//                 Authorization:'Bearer '+token
//             },
//             body:JSON.stringify(data),
//         }).then((response)=>response.json())
//         .then((responseJson)=>{
//             //resolve(responseJson);
//             return responseJson;
//         })
//         .catch((error) =>{
//             //reject(error);
//             console.log(error);
//         })

//         const printAddress = async () => {
//             const a = await ad;
//             return a;
//             console.log(a);
//           };

//          printAddress();

// }



// WEBPACK FOOTER //
// ./src/Services/AdminLogin.js